export default "__VITE_ASSET__8a6ffdda__"